import { ArrowUpRight } from "lucide-react";
import type { Brand } from "../brands";

export function BrandTile({ brand }: { brand: Brand }) {
  const cta = brand.external ? "Visit" : "Enter";
  const rel = brand.external ? "noopener noreferrer" : undefined;
  const target = brand.external ? "_blank" : undefined;
  const Icon = brand.icon;

  return (
    <a
      href={brand.href}
      rel={rel}
      target={target}
      className="jw-tile group flex flex-col gap-4 min-h-[280px] no-underline"
    >
      <div className="flex items-start justify-between">
        <p className="font-mono text-[0.65rem] tracking-[0.28em] uppercase text-jw-chrome-dim">
          {brand.category}
        </p>
        <ArrowUpRight
          className="h-5 w-5 text-jw-chrome-dim transition group-hover:text-jw-steel-light group-hover:rotate-12"
          aria-hidden
        />
      </div>

      <div className="flex items-center gap-2">
        <Icon className="h-5 w-5 text-jw-chrome-dim" aria-hidden />
        <h2 className={`font-display text-2xl font-bold tracking-wide ${brand.wordmarkClass}`}>
          {brand.name.toUpperCase()}
        </h2>
      </div>
      {brand.qualifier && (
        <p className="font-mono text-[0.7rem] tracking-[0.22em] uppercase text-jw-chrome-dim -mt-2">
          {brand.qualifier}
        </p>
      )}

      <div className="flex-1">
        <p className="font-display text-[0.92rem] text-jw-chrome-bright leading-snug font-medium">
          {brand.tagline}
        </p>
        <p className="mt-3 text-[0.85rem] leading-relaxed text-jw-text-muted">
          {brand.description}
        </p>
      </div>

      <div className="flex items-center justify-between pt-2 border-t border-jw-border">
        <span className="jw-tile-cta">
          {cta} <span aria-hidden>→</span>
        </span>
        {brand.external && (
          <span className="font-mono text-[0.65rem] tracking-[0.14em] uppercase text-jw-text-subtle">
            {brand.domainLabel}
          </span>
        )}
      </div>
    </a>
  );
}
